module.exports = __webpack_public_path__ + "img/sales.1ddc28fc.svg";